/* Translations are supplied by capkov-i18n-ostatni.liquid in the shared theme layout. */
(function () {
  var rdOiNode = null, rdOiStrings = null;
  function rdOE(value) {
    return String(value).replace(/&(?!(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]+);)/gi, '&amp;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function rdOT(key, fallback, asHtml) {
    var node = document.getElementById('capkov-i18n-ostatni');
    if (node && node !== rdOiNode) {
      try { rdOiStrings = JSON.parse(node.textContent); rdOiNode = node; } catch (e) { rdOiStrings = null; }
    }
    var value = rdOiStrings && rdOiStrings[key];
    if (typeof value !== 'string' || /translation missing|missing translation/i.test(value)) value = fallback;
    return asHtml ? rdOE(value) : value;
  }
/* Capkov PDP 2 (EU): animated delivery guide (static copy), info tabs, add-to-cart animation. No dependencies, defer. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* EU: guide copy is static from Liquid (capkov-rd-eta). No dates, no countdown. */
  function render() {}
  var played = typeof WeakSet === 'function' ? new WeakSet() : null;
  function play(el) { if (played && played.has(el)) return; if (played) played.add(el); requestAnimationFrame(function () { el.classList.add('is-play'); }); }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); play(e.target); } }); }, { threshold: .35 }) : null;
  function initEta() {
    document.querySelectorAll('[data-rdx-eta]:not([data-rdx-ok])').forEach(function (el) {
      el.setAttribute('data-rdx-ok', '1'); render(el);
      if (el.hasAttribute('data-rdv')) { vInit(el); return; }
      if (REDUCED || !io) el.classList.add('is-play'); else if (!el.querySelector('[data-rdx-how]')) io.observe(el);
    });
  }
  


  /* ---------- PDP r5: mini časová osa s dodávkou (Objednáš → Vyšijeme/Odešleme → U tebe), klepnutí na krok, přepínač dopravy ---------- */
  function vDet(el) {
    var pins = el.querySelectorAll('.rdv__pin'), i = +el.getAttribute('data-at') || 0, car = el.getAttribute('data-car') || 'pick';
    if (!pins[i]) return;
    var t = pins[i].getAttribute('data-det-' + car) || pins[i].getAttribute('data-det') || '', d = el.querySelector('[data-rdv-det]');
    if (d && d.textContent !== t) { d.textContent = t; d.classList.remove('is-in'); void d.offsetWidth; d.classList.add('is-in'); }
  }
  function vDrive(el, i) {
    var pins = el.querySelectorAll('.rdv__pin'), tr = el.querySelector('.rdv__track'); if (!pins.length || !tr) return;
    var prev = +el.getAttribute('data-at') || 0;
    tr.style.setProperty('--vx', i * 50); tr.style.setProperty('--p', i / 2);
    pins.forEach(function (p, k) { p.classList.toggle('is-on', k <= i); p.classList.toggle('is-cur', k === i); p.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    el.setAttribute('data-at', i);
    if (!REDUCED && prev !== i) { el.classList.add('is-drive'); clearTimeout(el.__dt); el.__dt = setTimeout(function () { el.classList.remove('is-drive'); }, 1150); }
    vDet(el);
  }
  function vPlay(el) {
    if (el.__vp) return; el.__vp = 1;
    if (REDUCED) { vDrive(el, 2); return; }
    setTimeout(function () { vDrive(el, 1); }, 300); setTimeout(function () { vDrive(el, 2); }, 1500);
  }
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { vio.unobserve(e.target); vPlay(e.target); } }); }, { threshold: .4 }) : null;
  function vInit(el) { vDet(el); if (REDUCED || !vio) vPlay(el); else vio.observe(el); }
  document.addEventListener('click', function (e) {
    var pin = e.target.closest && e.target.closest('.rdv__pin');
    if (pin) { var el = pin.closest('[data-rdv]'); if (el) { el.__vp = 1; vDrive(el, +pin.getAttribute('data-i') || 0); } return; }
    var cb = e.target.closest && e.target.closest('[data-rdv-car]');
    if (cb) {
      var el2 = cb.closest('[data-rdv]'); if (!el2) return;
      el2.setAttribute('data-car', cb.getAttribute('data-rdv-car'));
      el2.querySelectorAll('[data-rdv-car]').forEach(function (b) { b.setAttribute('aria-pressed', b === cb ? 'true' : 'false'); });
      render(el2); el2.__vp = 1; vDrive(el2, 2); vDet(el2);
    }
  });
  /* trust řada: čáry ikon se „nakreslí“ při zobrazení */
  var tio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { tio.unobserve(e.target); e.target.classList.add('is-in'); } }); }, { threshold: .5 }) : null;
  function initTrust() { document.querySelectorAll('.rdt:not([data-rdt-ok])').forEach(function (u) { u.setAttribute('data-rdt-ok', '1'); if (REDUCED || !tio) u.classList.add('is-in'); else { u.classList.add('is-pre'); tio.observe(u); } }); }

/* modaly důvěry (data-rd-modal): viz snippet capkov-rd-pdp-modals + assets/capkov-rd-trust-modal.css */

  /* ---------- tlačítko 3D = čip vlevo dole na hlavní fotce, na stejné lince a ve stejné výšce jako tlačítko zvětšení ---------- */
  function place3d() {
    var slot = document.querySelector('[data-rd3d-slot]'), g = document.querySelector('product-gallery');
    if (!slot || !g) return;
    if (slot.parentNode !== g) g.appendChild(slot);
    var m = g.querySelector('.product-gallery__media-list') || g.querySelector('.product-gallery__media'); if (!m) return;
    var mr = m.getBoundingClientRect(), gr = g.getBoundingClientRect(); if (!mr.width || !mr.height) return;
    var z = null, zs = g.querySelectorAll('.product-gallery__zoom .circle-button');
    for (var i = 0; i < zs.length; i++) { var r = zs[i].getBoundingClientRect(); if (r.width && r.left >= mr.left - 2 && r.right <= mr.right + 2) { z = r; break; } }
    var h = z ? z.height : 44, inset = z ? Math.max(8, Math.round(mr.right - z.right)) : 16, cy = z ? z.top + z.height / 2 : mr.bottom - 16 - h / 2;
    slot.classList.add('rd3d-slot--chip');
    var btn = slot.querySelector('.rd3d-btn'); if (btn) btn.style.height = h + 'px';
    slot.style.left = Math.round(mr.left - gr.left + inset) + 'px';
    slot.style.top = Math.round(cy - h / 2 - gr.top) + 'px';
    slot.setAttribute('data-placed', '1');
  }
  var t3 = 0; function sched3d() { clearTimeout(t3); t3 = setTimeout(place3d, 80); }
  window.addEventListener('resize', sched3d); window.addEventListener('load', sched3d);
  if (document.readyState !== 'loading') sched3d(); else document.addEventListener('DOMContentLoaded', sched3d);
  (function () { var g = document.querySelector('product-gallery'), m = g && (g.querySelector('.product-gallery__media-list') || g); if (m && window.ResizeObserver) new ResizeObserver(sched3d).observe(m); if (g) new MutationObserver(sched3d).observe(g, { attributes: true, subtree: true, attributeFilter: ['class'] }); })();
  setInterval(function () { if (!document.hidden) place3d(); }, 2500);

  /* "How it works" = smooth accordion inside the delivery card; the step animation plays on open */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rdx-how]'); if (!btn) return;
    var el = btn.closest('[data-rdx-eta]'); if (!el) return;
    var open = !el.classList.contains('is-open'); el.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    el.classList.remove('is-play');
    if (open) setTimeout(function () { el.classList.add('is-play'); }, 120);
  });

  /* ---------- tabs ---------- */
  function activate(root, name, focus) {
    root.querySelectorAll('[role=tab]').forEach(function (b) { var on = b.getAttribute('data-tab') === name; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on && focus) b.focus(); });
    root.querySelectorAll('[role=tabpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== name; });
  }
  function initTabs() {
    document.querySelectorAll('[data-rdi]:not([data-rdx-ok])').forEach(function (root) {
      root.setAttribute('data-rdx-ok', '1');
      var tabs = [].slice.call(root.querySelectorAll('[role=tab]'));
      var sel = root.querySelector('[role=tab][aria-selected=true]'); activate(root, sel ? sel.getAttribute('data-tab') : root.getAttribute('data-first'));
      tabs.forEach(function (b, i) {
        b.addEventListener('click', function () { activate(root, b.getAttribute('data-tab')); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, j = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : -1;
          if (j < 0) return; e.preventDefault(); j = (j + tabs.length) % tabs.length; activate(root, tabs[j].getAttribute('data-tab'), true);
        });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-rdx-goto]'); if (!a) return;
    var root = document.querySelector('[data-rdi]'); if (!root) return;
    e.preventDefault(); activate(root, a.getAttribute('data-rdx-goto') === 'delivery' ? 'vyroba' : a.getAttribute('data-rdx-goto'));
    root.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- add to cart: button -> Added + cart icon bounce ---------- */
  function bounceCart() {
    if (REDUCED) return;
    var c = document.querySelector('header [aria-controls="cart-drawer"], [aria-controls="cart-drawer"]'); if (!c) return;
    c.classList.remove('rdx-bounce'); void c.offsetWidth; c.classList.add('rdx-bounce'); setTimeout(function () { c.classList.remove('rdx-bounce'); }, 700);
  }
  document.addEventListener('variant:add', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('form') : null; var btn = f && f.querySelector('buy-buttons .button');
    if (!btn || btn.classList.contains('is-added')) return; bounceCart();
    var lab = btn.querySelector('div') || btn, old = lab.textContent;
    lab.textContent = rdOT("capkov.obchod.pairs_added", "Added"); btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); lab.textContent = old; }, 2200);
  });
  document.documentElement.addEventListener('cart:change', function (e) {
    if (!e.detail || e.detail.baseEvent !== 'variant:add') return;
    var btn = document.querySelector('.rd-atc .button'); if (!btn || btn.classList.contains('is-added')) return;
    var lab = btn.querySelector('div') || btn, old = lab.textContent; lab.textContent = rdOT("capkov.obchod.pairs_added", "Added"); btn.classList.add('is-added'); bounceCart();
    setTimeout(function () { btn.classList.remove('is-added'); lab.textContent = old; }, 2200);
  });
  document.addEventListener('rdx:added', bounceCart);
  document.addEventListener('rd:quickview:added', bounceCart);

  /* ---------- sold-out colours: title ---------- */
  function initSw() { document.querySelectorAll('label.color-swatch.is-disabled:not([title])').forEach(function (l) { l.title = rdOT("capkov.ostatni.sold_out_02ff659", "Sold out"); }); }


  /* ---------- kompaktní Popis / Detaily v nákupní kartě (pilulky + accordion) ---------- */
  function initPills() {
    var w = document.querySelector('[data-rd-pills]'); if (!w || w.__pl) return;
    var root = document.querySelector('[data-rdi]'); if (!root) return;
    w.__pl = 1;
    var btns = [].slice.call(w.querySelectorAll('[data-pill]')), got = 0;
    btns.forEach(function (b) {
      var k = b.getAttribute('data-pill'), src = root.querySelector('[data-panel="' + k + '"]'), dst = w.querySelector('[data-pill-body="' + k + '"]');
      if (!src || !dst || !src.children.length) { b.hidden = true; return; }
      while (src.firstChild) dst.appendChild(src.firstChild); got++;
      var tab = root.querySelector('[role=tab][data-tab="' + k + '"]'); if (tab) tab.hidden = true;
      src.hidden = true; src.setAttribute('data-pill-moved', '');
    });
    if (!got) { w.hidden = true; return; }
    /* ve sekci dole zůstane jen Péče; bez ní se sekce schová */
    var care = root.querySelector('[role=tab][data-tab="pece"]');
    if (care) { root.setAttribute('data-first', 'pece'); care.click(); } else { var sh = root.closest('.shopify-section'); (sh || root).style.display = 'none'; }
    function setOpen(b, open) {
      var p = document.getElementById(b.getAttribute('aria-controls')); if (!p) return;
      b.setAttribute('aria-expanded', open ? 'true' : 'false'); p.classList.toggle('is-open', open);
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        btns.forEach(function (o) { if (o !== b) setOpen(o, false); });
        setOpen(b, open);
      });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { setOpen(b, false); }
        var vis = btns.filter(function (x) { return !x.hidden; }), i = vis.indexOf(b);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); vis[(i + (e.key === 'ArrowRight' ? 1 : vis.length - 1)) % vis.length].focus(); }
      });
    });
  }
  function scan() { initEta(); initTabs(); initPills(); initSw(); initTrust(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
  var t = 0; new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

})();
